import { useDebouncedCallback } from '../../../../../../../../../../../../../../../../../../hooks/useDebouncedCallback'
import { useInvoiceEditorForm } from '../../../../../../../../../../../../../../contexts/invoiceEditorFormContext'
import { useUpdateDependentLineValues } from '../../../../../../../../../../hooks/useUpdateDependentLineValues'
import { CurrencyInput } from '../../../../../../../../../CurrencyInput'
import { CommonInvoiceLineFieldProps } from '../../../../../../types/commonInvoiceLineFieldProps'

type InvoiceLineTotalIncludingVatProps = CommonInvoiceLineFieldProps

export const InvoiceLineTotalIncludingVat = ({ disabled = false, lineIndex }: InvoiceLineTotalIncludingVatProps) => {
  const { invoiceEditorForm, trackInvoiceEditor } = useInvoiceEditorForm()
  const { FormItem, getValues } = invoiceEditorForm
  const { handleTotalIncludingVatChange, handleUnitPriceChange } = useUpdateDependentLineValues()

  const handleDebouncedInputNumberChange = useDebouncedCallback((total: number) =>
    trackInvoiceEditor('Form - Invoice lines - Total incl. VAT changed', {
      total,
    }),
  )

  return (
    <FormItem
      name={`invoiceLines.${lineIndex}.totalIncludingVat`}
      render={({ field: { value, onChange, ...props } }) => {
        return (
          <CurrencyInput
            {...props}
            disabled={disabled}
            value={value}
            onBlur={() => {
              handleUnitPriceChange(lineIndex, getValues(`invoiceLines.${lineIndex}.unitPrice`))
            }}
            onChange={(totalIncludingVat) => {
              handleTotalIncludingVatChange(lineIndex, totalIncludingVat)
              onChange(totalIncludingVat)
              handleDebouncedInputNumberChange(totalIncludingVat)
            }}
            size="sm"
          />
        )
      }}
    />
  )
}
